import PropTypes from "prop-types";
import Steps from "./Steps";

import { useParams } from "react-router-dom";
import { KeikkaDataProvider } from "src/context/KeikkaDataContext";
import { StepLogProvider } from "src/context/StepLogContext";
import { KeikkaBetoniProvider } from "src/context/KeikkaBetoniContext";
import { NavProvider } from "src/context/navContext";
import { ToimitusProvider } from "src/context/ToimitusContext";
import { KeikkaLaskuProvider } from "src/context/KeikkaLaskuContext";
import { TarjousProvider } from "src/context/TarjousContext";
import { StatusProvider } from "src/context/StatusContext";
import { AttachmentsProvider } from "src/context/AttachmentsContext";
import AuthAccess from "src/data/auth/authAccess/AuthAccess";

export default function StepsCore(props) {
  let params = useParams();
  let keikkaId = parseInt(params.keikkaId || props.keikkaId || 0);
  const isConnected = props.isConnected || false;

  return (
    <AuthAccess page="list" showError>
      <NavProvider>
        <KeikkaDataProvider keikkaId={keikkaId}>
          <KeikkaBetoniProvider keikkaId={keikkaId}>
            <StepLogProvider keikkaId={keikkaId}>
              <ToimitusProvider keikkaId={keikkaId}>
                <AttachmentsProvider keikkaId={keikkaId}>
                  <KeikkaLaskuProvider>
                    <TarjousProvider>
                      <StatusProvider>
                        <Steps isConnected={isConnected} />
                      </StatusProvider>
                    </TarjousProvider>
                  </KeikkaLaskuProvider>
                </AttachmentsProvider>
              </ToimitusProvider>
            </StepLogProvider>
          </KeikkaBetoniProvider>
        </KeikkaDataProvider>
      </NavProvider>
    </AuthAccess>
  );
}

StepsCore.propTypes = {
  isConnected: PropTypes.bool,
  keikkaId: PropTypes.number,
};
